import React from 'react';
import * as XLSX from 'xlsx';
import AdminManageSettingsDataUpload from './admin-manage-settings-data-upload';
import AdminManageSettingsComparisonTable from './admin-manage-settings-comparison-table';
import * as adminService from '../../services/admin-service';

// ---------------------------------------------------------------------------
// Template download (client-side, no server round-trip)
// ---------------------------------------------------------------------------
const handleDownloadBaseRentValidationRulesTemplate = () => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet([['Market', 'Property Type', 'Absolute Min', 'Absolute Max']]);
  ws['!cols'] = [{ wch: 25 }, { wch: 18 }, { wch: 14 }, { wch: 14 }];
  XLSX.utils.book_append_sheet(wb, ws, 'Template');
  XLSX.writeFile(wb, 'base_rent_validation_rules_template.xlsx');
};

const baseRentValidationRulesConfig = {
  title: 'Manage Base Rent Validation Rules',
  description: 'Upload an Excel file containing broker verification base rent validation rule bounds to compare with existing records and update as needed.',
  uploadTitle: 'Upload Base Rent Validation Rules File',
  entityName: 'base rent validation rules',
  fileInputId: 'base-rent-validation-rules',
  templateDownload: {
    show: true,
    buttonText: 'Download Template File',
    onDownload: handleDownloadBaseRentValidationRulesTemplate,
  },
  uploadService: adminService.uploadBaseRentValidationRulesFile,
  bulkUpdateService: adminService.bulkUpdateBaseRentValidationRules,
  downloadFileService: adminService.downloadBaseRentValidationRulesFile,
  getFileInfoService: adminService.getBaseRentValidationRulesFileInfo,
  // Base Rent Validation Rules use a composite (market, property_type) natural key.
  // The backend synthesizes a `record_key` ("market||property_type") on each comparison
  // row so the shared comparison table (which only supports a single idField) can be
  // reused unchanged.
  idField: 'record_key',
  columns: [
    { field: 'market', label: 'Market', className: 'admin-pool-comparison-col-name' },
    { field: 'property_type', label: 'Property Type', className: 'admin-pool-comparison-col-office' },
    { field: 'absolute_min', label: 'Absolute Min', className: 'admin-pool-comparison-col-description' },
    { field: 'absolute_max', label: 'Absolute Max', className: 'admin-pool-comparison-col-description' },
  ],
  viewAllConfig: {
    entityName: 'Base Rent Validation Rules',
    fetchAllService: adminService.fetchBaseRentValidationRules,
    // Composite natural key: no single idField, so idFields is used instead.
    idFields: ['market', 'property_type'],
    searchFields: ['market', 'property_type'],
    columns: [
      { key: 'market', label: 'MARKET', width: '200px' },
      { key: 'property_type', label: 'PROPERTY TYPE', width: '160px' },
      { key: 'absolute_min', label: 'ABSOLUTE MIN', width: '140px' },
      { key: 'absolute_max', label: 'ABSOLUTE MAX', width: '140px' },
    ],
    editable: true,
    editFields: ['absolute_min', 'absolute_max'],
    updateService: adminService.updateBaseRentValidationRule,
    historyService: adminService.fetchBaseRentValidationRuleHistory,
  },
};

const AdminManageBaseRentValidationRules = () => {
  return (
    <AdminManageSettingsDataUpload
      config={baseRentValidationRulesConfig}
      ComparisonTableComponent={AdminManageSettingsComparisonTable}
    />
  );
};

export default AdminManageBaseRentValidationRules;
